import React from "react";
import classNames from "classnames";

interface Props {
  onClick: () => void
  isSelected: boolean
  type: server.dto.ClientPaymentMethodTypes
  classNames?: string
}

const Icons: { [key in server.dto.ClientPaymentMethodTypes]: string } = {
  invoice: "icon-file-text",
  card: "icon-credit-card",
  sepaDebit: "icon-eur",
  notSet: "icon-x"
};

const Labels: { [key in server.dto.ClientPaymentMethodTypes]: string } = {
  invoice: RESX.Invoice.xInvoice,
  card: RESX.PaymentMethods.Card,
  sepaDebit: RESX.PaymentMethods.SepaDebit,
  notSet: "Not set"
};

const PaymentMethodTabButton = (props: Props) => {
  const { type, onClick, isSelected } = props;

  const classes = classNames("grow1 flex padding-big justify-center align-center radius-big", props.classNames, {
    "borders hoverable": !isSelected,
    "blue-bg white-text": isSelected
  });

  return <div
    onClick={onClick}
    className={classes}
  >
    <div className="margin-right">
      <i className={Icons[type]} />
    </div>
    <div>
      <h3>{Labels[type]}</h3>
    </div>
  </div>;
};

export default PaymentMethodTabButton;